import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
const SelectField = props => {
    const { data, field, className } = props;
    const { t } = useTranslation(I18N_NAMESPACES.form);
    return (_jsx("div", { className: "a-select__wrapper", children: _jsxs(Field, Object.assign({}, field, { component: "select", className: className, children: [_jsx("option", { value: "", disabled: true, children: t('form:form.select.option') }), data.options.map(item => {
                    return (_jsx("option", { value: item[data.valueLookup], children: item[data.labelLookup] }, item[data.keyLookup]));
                })] })) }));
};
export { SelectField };
